import Vue from 'vue'
import VueI18n from 'vue-i18n'
import AppLayout from './layout/index.vue'
import router from './router'
import store from './store'
import { ApiService } from './services/api.service'
import { languages, defaultLocale } from './i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import {
  faPhoneAlt,
  faEnvelope,
  faBuilding,
  faCalendarAlt,
  faYenSign,
  faUser,
  faMapMarkerAlt,
  faTimes,
  faCaretDown
} from '@fortawesome/free-solid-svg-icons'
import { faCommentDots, faDotCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import './mixins'

import './scss/style.scss'

Vue.use(VueI18n)
library.add(
  faTwitter, faPhoneAlt, faEnvelope, faCommentDots,
  faBuilding, faCalendarAlt, faYenSign, faUser,
  faMapMarkerAlt, faDotCircle, faTimes, faCaretDown
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
const messages = Object.assign(languages)
const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'ja',
  messages
})

new Vue({
  name: 'Root',
  router,
  i18n,
  store,
  mounted () {
    store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
    window.addEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },
  beforeCreate () {
    // TODO: uncomment below for real domain
    store.commit('organization/SET_DOMAIN', window.location.hostname)
    // TODO: remove below for real domain
    // Dummy domain
    // store.commit('organization/SET_DOMAIN', 'tollywood-dev.eigaland.com')
    ApiService.getCinemaDetail(this.$route.query.webKey).then(res => {
      store.commit('cinema/SET_CINEMA', res)
      const {
        backgroundColor,
        btnFontColor,
        cardBackgroundColor,
        labelBackgroundColor,
        mainColor,
        mainFontColor,
        secondaryFontColor,
        btnTextColorSelected,
        navBarFontColor,
        navBarFontColorSelected,
        navBarBackgroundColor,
        metadata,
        favicon
      } = res.data
      const root = document.documentElement
      // TODO: api meta tag mapping
      // parse JSON data
      var meta
      try {
        meta = metadata ? JSON.parse(metadata) : ''
      } catch (e) {
        console.log(e)
        meta = ''
      }
      // var meta = metadata ? JSON.parse(metadata) : ''
      // console.log(meta)
      if (meta) {
        Object.keys(meta).forEach(key => {
          if (key !== 'title') {
            // create meta tags
            var metaTag = document.createElement('meta')
            // metaTag.name = 'description'
            // metaTag.content = meta.description
            metaTag.name = key
            metaTag.content = meta[key]
            document.getElementsByTagName('head')[0].appendChild(metaTag)
          }
        })
      }
      
      document.title = meta.title
      var faviconTag = document.createElement('link')
      faviconTag.rel = 'icon'
      faviconTag.href = `${favicon}`
      // document.getElementsByTagName('head')[0].appendChild(metaTag)
      document.getElementsByTagName('head')[0].appendChild(faviconTag)
      // TODO: api colour theme mapping
      root.style.setProperty('--Main-font-color', mainFontColor)
      root.style.setProperty('--Secondary-font-color', secondaryFontColor)
      root.style.setProperty('--Main-color', mainColor)
      root.style.setProperty('--Background-color', backgroundColor)
      root.style.setProperty('--Card-background-color', cardBackgroundColor)
      root.style.setProperty('--Label-background-color', labelBackgroundColor)
      root.style.setProperty('--Button-font-color', btnFontColor)
      root.style.setProperty('--Button-selected-font-color', btnTextColorSelected)
      root.style.setProperty('--Navbar-font-color', navBarFontColor)
      root.style.setProperty('--Navbar-selected-font-color', navBarFontColorSelected)
      root.style.setProperty('--Navbar-background-color', navBarBackgroundColor)
      if (backgroundColor === '#000000') {
        root.style.setProperty('--Menu-btn-color', '#cccccc')
        root.style.setProperty('--Menu-btn-selected-color', '#ffffff')
      }
      store.commit('theme/SET_IS_INIT_THEME')
    }).catch(error => {
      console.error(error.response)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },
  render: h => h(AppLayout)

}).$mount('#app')
